import { FC, useEffect, useState } from "react";
import { useAppDispatch } from "common/redux/core/root.reducer";

import { SignalrActions } from "common/enums/signalr-actions.enum";
import useCustomTranslation from "common/hooks/useCustomTranslation";
import useSignalR from "common/hooks/useSignalR";
import { appActions } from "common/redux/app/app.slice";

import useEngagmentDetails from "modules/engagement-dashboard/hooks/useEngagementDetails";
import { GrcSyncToastDetails } from "modules/engagement-dashboard/util/grc-sync.util";

interface GrcSyncListenerProps {
  clientId: string;
  engagementId: string;
}
/**
 * Global listener for GRC sync status messages across Optro and ServiceNow.
 * Rendered from AuthorizedLayout so the toast fires regardless of which
 * engagement page is currently mounted. Skips duplicate fan-out deliveries by
 * message text.
 */
const GrcSyncListener: FC<GrcSyncListenerProps> = ({
  clientId,
  engagementId
}) => {
  const dispatch = useAppDispatch();
   const { t } = useCustomTranslation(["engagementDashboard", "home"]);
   const { engagementAccess } = useEngagmentDetails();

  const { message: grcSyncSignalRMessage } = useSignalR({
    uniqueListenerName: "ExternalSyncStatusGlobal",
    clientId,
    engagementId,
    actions: [SignalrActions.EXTERNAL_SYNC_STATUS]
  });

  const [lastMessageText, setLastMessageText] = useState("");

  useEffect(() => {
    if (!grcSyncSignalRMessage) {
      return;
    }

    const messageText =
      (grcSyncSignalRMessage as unknown as { message?: string }).message ??
      "";

    if (messageText && messageText === lastMessageText) {
      return;
    }

    const toastDetails = GrcSyncToastDetails(grcSyncSignalRMessage, t, engagementAccess);
    if (!toastDetails) {
      return;
    }

    setLastMessageText(messageText);
    dispatch(appActions.setToastDetails(toastDetails));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [grcSyncSignalRMessage]);

  return null;
};

export default GrcSyncListener;
